/**
 * VD add-on cart patch
 * Appends ticked "Customize your Setup" add-ons to cart/add requests built by other
 * scripts (Globo Product Options), because Globo's cloned Add to Cart button bypasses
 * the form "submit" event used by assets/complementary-products.js.
 * Debug: open a product page with ?vd_addon_debug=1 and watch the console.
 */
(function () {
  if (window.__vdAddonCartPatch) return;
  window.__vdAddonCartPatch = true;

  var DEBUG = /[?&]vd_addon_debug=1/.test(window.location.search);
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[VD add-ons]'].concat([].slice.call(arguments)));
    }
  }

  function isCartAdd(url) {
    try {
      var path = new URL(String(url), window.location.href).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return false;
    }
  }

  function getSelection() {
    var box = document.querySelector('.complementary-products-checkboxes');
    var section = box && box.closest('.js-product');
    var form = section && section.querySelector('.js-product-form-main');
    if (!box || !form || typeof box._getSelectedComplementaryItems !== 'function') return null;

    var idInput = form.querySelector('input[name="id"]');
    var mainId = parseInt(idInput && idInput.value, 10);
    if (!mainId) return null;

    var addons = box._getSelectedComplementaryItems();
    if (!addons || !addons.length) return null;

    return { mainId: mainId, addons: addons };
  }

  function patchBody(body) {
    if (typeof body !== 'string') {
      log('skip: body is not a string (' + Object.prototype.toString.call(body) + ')');
      return body;
    }

    var payload;
    try {
      payload = JSON.parse(body);
    } catch (e) {
      log('skip: body is not JSON', body.slice(0, 120));
      return body;
    }
    if (!payload || !Array.isArray(payload.items)) {
      log('skip: no items array');
      return body;
    }

    var sel = getSelection();
    if (!sel) return body;

    // Theme interceptor (non-Globo products) already added them: do nothing.
    var already = payload.items.some(function (it) {
      return it && it.properties && it.properties._bundle_addon;
    });
    if (already) {
      log('skip: add-ons already in request');
      return body;
    }

    // Find the main product line (ignore Globo's own option add-on lines).
    var mainIndex = -1;
    for (var i = 0; i < payload.items.length; i++) {
      var it = payload.items[i];
      if (it && Number(it.id) === sel.mainId &&
          !(it.properties && it.properties._gpo_parent_product_group)) {
        mainIndex = i;
        break;
      }
    }
    if (mainIndex === -1) {
      log('skip: main variant ' + sel.mainId + ' not in request (unrelated add)');
      return body;
    }

    var extra = sel.addons.map(function (a) {
      return {
        id: Number(a.id),
        quantity: a.quantity,
        properties: {
          _bundle_addon: 'yes',
          _bundle_parent_variant: String(sel.mainId)
        }
      };
    });

    // Insert BEFORE the main line so the main product stays where Globo expects it
    // (Globo reads the last item of the response as the main product).
    Array.prototype.splice.apply(payload.items, [mainIndex, 0].concat(extra));

    log('patched request', payload.items);
    return JSON.stringify(payload);
  }

  // ---- fetch ----
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && init && init.body && isCartAdd(url)) {
          var patched = patchBody(init.body);
          if (patched !== init.body) init = Object.assign({}, init, { body: patched });
        }
      } catch (e) {
        log('fetch patch error', e);
      }
      return origFetch.call(this, input, init);
    };
  }

  // ---- XMLHttpRequest (covers jQuery $.ajax) ----
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      this.__vdCartAdd = String(method).toUpperCase() === 'POST' && isCartAdd(url);
    } catch (e) {}
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__vdCartAdd) {
      try { body = patchBody(body); } catch (e) { log('xhr patch error', e); }
    }
    return origSend.call(this, body);
  };
})();